import { styled } from "styled-components";
const SegmentedControlWrapper = styled("div")(
  {
    borderRadius: 2,
    display: "flex",
    transform: "translateZ(0)"
  },
  ({ $disabled }) => $disabled ? {
    backgroundColor: "rgba(0, 0, 0, 0.05)"
  } : {
    backgroundColor: "white"
  },
  ({ $widthMode }) => ({
    "fill-container": {
      width: "100%"
    },
    "fit-content": {
      width: "max-content"
    }
  })[$widthMode]
);
export {
  SegmentedControlWrapper
};
